import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { environment } from '../environments/environment';
import { LoginService } from './login.service';
import { ChatNotificationService } from './services/chat-notification.service';

@Component({
    selector: 'app-logout',
    templateUrl: 'logout.component.html',
    encapsulation: ViewEncapsulation.None
})
export class LogoutComponent implements OnInit {
    private appURL: string = environment.apiUrl;
    private PortalURL: string = environment.portalUrl;
    model: any;
    currentUser: any;
    constructor(
        private router: Router,
        private _flashMessagesService: FlashMessagesService,
        private loginservice: LoginService,
        private chatNotificationService: ChatNotificationService
    ) { }
    ngOnInit(): void {
        this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
        this.model = [];
    }

    public logout() {
        // Handle chat notification logout
        this.chatNotificationService.handleLogout();
        
        localStorage.clear();
        this.loginservice.delCheckout(this.model['customer_id'], this.currentUser).subscribe(
            data => {
                return true;
            },
            error => {
                alert('Network Error In Logout component deleteCheckout API');
            });
        this.loginservice.delCustomerCheckout(this.model.id, this.currentUser)
            .subscribe(data => {
            },
                error => {
                    alert('Network Error In Logout component deleteCustomerCheckout API');
                });

        localStorage.clear();
        this.router.navigateByUrl('/');
        if (this.loginservice.getLocalSession('currentSite') === null) {
            localStorage.removeItem('currentUser');
            localStorage.removeItem('currentSite');
            localStorage.removeItem('currentOrg');
            localStorage.removeItem('currentEmp');
            localStorage.removeItem('currentOption');
            this.router.navigateByUrl('/');
        } else {
            localStorage.removeItem('currentUser');
            localStorage.removeItem('currentSite');
            localStorage.removeItem('currentOrg');
            localStorage.removeItem('currentEmp');
            localStorage.removeItem('currentOption');
            window.location.href = this.PortalURL;
        }
    };

}



// WEBPACK FOOTER //
// ./src/app/logout.component.ts